import { HttpErrorResponse } from '@angular/common/http';
import { Component } from '@angular/core';
import {
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { ActivatedRoute, Params } from '@angular/router';
import { finalize } from 'rxjs/operators';
import { WkErrorMessage } from '../../model/wk-error-response';
import { WkPasswordService } from '../../services/wk-password.service';
import { passwordMatch } from '../../validators/match-password.validator';
import { strongPassword } from '../../validators/strong-password.validator';

@Component({
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.scss'],
  standalone: false,
})
export class ChangePasswordComponent {
  private token: string;

  submitted = false;
  success = false;
  failed = false;
  fetching = false;
  failMessage: string;

  formGroup = new UntypedFormGroup({
    password: new UntypedFormControl('', [Validators.required, strongPassword]),
    repeatPassword: new UntypedFormControl('', [Validators.required]),
  });

  constructor(
    private readonly passwordService: WkPasswordService,
    private readonly activatedRoute: ActivatedRoute
  ) {
    this.formGroup.valueChanges.subscribe(() => {
      this.formGroup.controls.repeatPassword.updateValueAndValidity({
        emitEvent: false,
      });
      this.closeMessages();
    });

    this.activatedRoute.queryParams.subscribe((params: Params): void => {
      this.token = params.token;
    });

    this.formGroup.controls.repeatPassword.setValidators(
      passwordMatch(this.formGroup.controls.password)
    );
  }

  onSubmit(): void {
    this.submitted = true;

    if (this.formGroup.valid) {
      this.create();
    }
  }

  private create(): void {
    this.closeMessages();
    this.fetching = true;
    this.passwordService
      .changePassword({
        token: this.token,
        password: btoa(this.formGroup.value.password),
      })
      .pipe(finalize(() => (this.fetching = false)))
      .subscribe({
        next: () => {
          this.success = true;
        },
        error: (err: HttpErrorResponse): void => {
          this.failed = true;
          this.failMessage = (
            JSON.parse(err.message) as WkErrorMessage
          ).messageKey;
        },
      });
  }

  private closeMessages(): void {
    this.failed = false;
    this.success = false;
    this.submitted = false;
  }
}
